export default __webpack_public_path__ + "static/media/ic_form1.682bfff8.svg";